import SVG from "svg.js";
import { Store } from "vuex";
import { BodyConfig } from ".";
import { InfoWindow } from "./InfoWindow";

export class HeartNeedDataText extends InfoWindow {
  shiftX = 200;
  shiftY = 300;

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
    this.shiftContent();
  }

  getExtraData() {
    if (this.atom && this.atom.value === 1) {
      this.extraData = { text: "Need Data" };
    } else {
      this.svgGroup.hide();
    }
  }
}
